import React, { useState, useEffect } from 'react';
import CountDownComponent from 'react-countdown-now';

export default ({ initialMinute = 1, initialSeconds = 0, timeUp, styles, classnames, expiredAt, display}) => {
    const [date, setDate] = useState(Date.now() + 10000);

    useEffect(() => {
        if (expiredAt > Date.now() + 10000) {
            setDate(expiredAt)
        } else {
            let timeCount = (initialMinute * 60 + initialSeconds) * 1000;

            setDate(Date.now() + timeCount);
        }
    }, [initialMinute, initialSeconds, expiredAt])

    const renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            // time's up
            timeUp(true)
            return null
        } else {
            return (
                <span className={classnames} style={styles}>
                    {
                        !display
                            ? null :
                            <span>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</span>
                    }
                </span>
            )
        }
    }
    return (
        <CountDownComponent date={date} renderer={renderer} />
    )
}
